import styled from "styled-components";

export const List = styled.div`
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f8fafc;
    border-radius: 6px;
    margin: 0 -8px;
    padding: 10px 8px;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const Avatar = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background: center center url(${({ src }) => src}) no-repeat;
  background-color: #e2e8f0;
  background-size: cover;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;

  .name {
    font-weight: 600;
    font-size: 16px;
    color: #1a1a1a;
    line-height: 1.3;
  }

  .subtitle {
    font-size: 13px;
    color: #64748b;
    line-height: 1.2;
  }
`;
